export interface CompliantLike {
  compliant?: boolean
  relaxed_compliant?: boolean | null
}

// Treat `relaxed_compliant: true` as compliant.
export function isCompliant(
  validation: CompliantLike | undefined,
): boolean | undefined {
  if (!validation) return undefined
  if (validation.relaxed_compliant === true) return true
  return validation.compliant
}
